export default __webpack_public_path__ + "static/media/shrutiCsharplow.d8894923.wav";